module.exports = __webpack_public_path__ + "static/media/loader-spinner.2f920354.svg";